import { Button } from "@mui/material";
import { Iqrcode } from "./types";
import { useDispatch } from "react-redux";
import { updateQrLogo } from "../state/mainSlice";
import UploadFileIcon from '@mui/icons-material/UploadFile';

const LogoUploader = () => {
    const dispatch = useDispatch();

    const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
                const result = e.target?.result;
                if (result && typeof result === "string") {
                    dispatch(updateQrLogo(result));
                }
            };
            reader.readAsDataURL(file);
        }
    };

    return(
        <Button
            variant="contained"
            component="label"
            sx={{ marginBottom: 2, marginTop: -2, color: '#fff', backgroundColor: "#000", textTransform: "none"}}
            startIcon={<UploadFileIcon /> }
        >
            Upload a logo
            <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleLogoUpload}
            />
        </Button>
    )
}

export default LogoUploader;